import { makeStyles } from '@material-ui/core/styles';

export const pageHeaderHeight = 48;

const useStyles = makeStyles((theme) => {
    const isLightTheme = theme.palette.type === 'light';

    return {
        root: {
            boxShadow: theme.shadows[4],
            zIndex: theme.zIndex.appBar,

            '& .MuiTextField-root': {
                ...theme.mixins.flex.flexDirectionRow,
                ...theme.mixins.flex.alignItemsCenter,
            },

            '& .MuiFormHelperText-root': {
                marginLeft: theme.spacing(1),
                whiteSpace: 'nowrap',
            },

            '& .MuiInputLabel-root': {
                fontSize: '0.75rem',
                top: theme.spacing(-0.25),
            },

            '& .MuiInputBase-input': {
                fontSize: 18,
                paddingTop: 0,
                marginTop: theme.spacing(-1),
            },
        },
        pageHeader: {
            height: pageHeaderHeight,
            backgroundColor: isLightTheme ? theme.palette.background.default : theme.palette.background.paper,

            '&.MuiToolbar-regular': {
                minHeight: pageHeaderHeight,
                paddingLeft: 20,
                paddingRight: 20,
            },
        },
        pageTitle: {
            ...theme.mixins.flex.displayInlineFlex,
            ...theme.mixins.flex.alignItemsCenter,
            ...theme.mixins.flex.flexWrapNowrap,
            fontSize: 18,

            '& .MuiSvgIcon-fontSizeSmall': {
                fontSize: '0.95rem',
            },
        },
        pageTitleText: {
            marginRight: theme.spacing(1),
        },
    };
});

export default useStyles;
